<!-- Spinner while statuses are being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading downloads. Click below try again.
    <button hc-button size="lg" (click)="reloadDownloads()">Reload Downloads</button>
</div>

<div [hidden]="loadError || loading">
    <div class="admin-downloads-header">
        <h2><hc-icon fontSet="fa" fontIcon="fa-download"></hc-icon> Downloads</h2>

        <button hc-button buttonStyle="link-inline" (click)="openInstructions(instructionsModal)">
            <hc-icon class="icon-left" fontSet="fa" fontIcon="fa-file-text-o" hcIconSm></hc-icon>
            How-To Guide
        </button>
    </div>

    <div class="admin-downloads-table-container">
        <hc-tab-set direction="horizontal" (selectedTabChange)="tabClick($event)">
            <hc-tab tabTitle="Technology & Services Catalog">
                <div class="admin-downloads-table-action-bar">
                    <button hc-button buttonStyle="secondary" (click)="openGenerateModal(generateModal)">Generate Catalog</button>
                    <button hc-button (click)="openAddEditModal(addEditModal)">Add Version</button>
                </div>
            </hc-tab>
            <hc-tab tabTitle="Catalog Spreadsheet">
                <div class="admin-downloads-table-action-bar">
                    <button hc-button buttonStyle="secondary" (click)="generateDownload('metadata')">Generate Spreadsheet</button>
                    <button hc-button (click)="openAddEditModal(addEditModal)">Add Version</button>
                </div>
            </hc-tab>
        </hc-tab-set>
    
        <table hc-table [borders]="false" class="admin-downloads-table" [dataSource]="dataSource" hcSort>
            <!-- Version Column -->
            <ng-container hcColumnDef="version">
                <th hc-index-cell *hcHeaderCellDef hc-sort-header id="versionHeader">Version</th>
                <td hc-index-cell *hcCellDef="let element">{{ element.version }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container hcColumnDef="name">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
                <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
            </ng-container>
    
            <!-- Start Date Column -->
            <ng-container hcColumnDef="startDate">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="startDateHeader">Start Date</th>
                <td hc-cell *hcCellDef="let element">{{ element.startDate | date: 'shortDate' }}</td>
            </ng-container>
    
            <!-- End Date Column -->
            <ng-container hcColumnDef="endDate">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="endDateHeader">End Date</th>
                <td hc-cell *hcCellDef="let element">{{ element.endDate | date: 'shortDate' }}</td>
            </ng-container>

            <!-- Publish Date Column -->
            <ng-container hcColumnDef="publishDate">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="publishDateHeader">Publish Date</th>
                <td hc-cell *hcCellDef="let element">{{ element.publishDate | date: 'shortDate' }}</td>
            </ng-container>

            <!-- Icon Actions Column -->
            <ng-container hcColumnDef="actions" justify="center"> 
                <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
                <td hc-cell *hcCellDef="let element">
                    <div class="hc-table-actions">
                        <span hcMenuIcon class="fa fa-download hc-action-ico" hcTooltip="Download item" (click)="downloadElement(element)"></span>
                        <span hcMenuIcon class="fa fa-trash hc-action-ico" hcTooltip="Remove download" (click)="removeDownload(element)"></span>
                        <span hcMenuIcon class="fa fa-pencil hc-action-ico" hcTooltip="Edit download" (click)="openAddEditModal(addEditModal, element)"></span>
                    </div>
                </td>
            </ng-container>
    
            <tr hc-header-row *hcHeaderRowDef="displayedColumns"></tr>
            <tr hc-row *hcRowDef="let row; columns: displayedColumns"></tr>
        </table>
    
        <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
            <span class="hc-empty-table-block-ico hc-empty-ico"></span>
            <span class="hc-empty-table-block-msg">No downloads to show.</span>
        </div>
    
        <hc-pagination [length]="listLength" [pageSize]="pageSize"></hc-pagination>
    </div>
</div>

<ng-template #addEditModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>{{ data.edit ? 'Edit' : 'Add' }} Download</hc-modal-header>
        <hc-modal-body>
            <form [formGroup]="adminDownloadForm" class="admin-download-form">
                <hc-form-field>
                    <hc-label>Name:</hc-label>
                    <input hcInput formControlName="name" placeholder="Enter name" [required]="true" />
                    <hc-error>A name is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Version Number:</hc-label>
                    <hc-label-ext>Used for sorting. The greatest value is considered the current version.</hc-label-ext>
                    <input hcInput type="number" formControlName="version" placeholder="Enter version number" [required]="true" />
                    <hc-error>A version number is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Start Date:</hc-label>
                    <input hcInput [hcDatepicker]="picker1" formControlName="startDate" placeholder="Enter date..." [required]="true" />
                    <hc-datepicker-toggle hcSuffix [for]="picker1"></hc-datepicker-toggle>
                    <hc-datepicker #picker1></hc-datepicker>
                    <hc-error>A valid date is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>End Date:</hc-label>
                    <input hcInput [hcDatepicker]="picker2" formControlName="endDate" placeholder="Enter date..." [required]="true" />
                    <hc-datepicker-toggle hcSuffix [for]="picker2"></hc-datepicker-toggle>
                    <hc-datepicker #picker2></hc-datepicker>
                    <hc-error>A valid date is required</hc-error>
                </hc-form-field>
                <hc-form-field *ngIf="!data.edit">
                    <hc-label>Select file to upload:</hc-label>
                    <hc-file-uploader formControlName="file" [multiple]="false" fileTypes="application/pdf,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"></hc-file-uploader>
                    <hc-error>A PDF or Excel file is required</hc-error>
                </hc-form-field>
            </form>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button hc-button buttonStyle="primary"
                [disabled]="!adminDownloadForm.valid"
                (click)="data.edit ? editDownload() : addDownload()">
                {{ data.edit ? 'Update' : 'Add' }}
            </button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>

<ng-template #generateModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>Generate {{ data.header }}</hc-modal-header>
        <hc-modal-body>
            <hc-form-field>
                <hc-label>Name:</hc-label>
                <input hcInput [formControl]="adminGenerateForm" placeholder="Enter name" class="name-input"
                    [required]="true" />
                <hc-error>A name is required</hc-error>
            </hc-form-field>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button hc-button buttonStyle="primary"
                [disabled]="!adminGenerateForm.valid"
                (click)="generateDownload(data.type); dismiss();">
                Generate
            </button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>

<ng-template #instructionsModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>Admin Downloads How-To</hc-modal-header>
        <hc-modal-body class="admin-downloads-instructions">
            <article>
                <h3>Naming Conventions</h3>

                <p>
                    Technology & Services Catalog: <strong>HC Catalog QN YYYY.pdf</strong><br>
                    Catalog Version: <strong>YYQVV1</strong><br>
                    <em>Quarter represents the new quarter/the quarter Sales will use it.</em>
                </p>
                <p>
                    Catalog Spreadsheet: <strong>HC Catalog Spreadsheet QN YYYY.csv</strong><br>
                    Catalog version: <strong>YYQVV2</strong>
                </p>
                <br>

                <h3>Updating the Tech and Services Catalog</h3>

                <p>Complete this task on the first day of each quarter to load a version that shows the current state and previous quarter changes. Sales will use this version for the new quarter. For example, if I'm uploading on Jan 1, the file would be Q1 2024, and the dates would be Sept 1 to Dec 31 2023.</p>

                <h4>Part 1: Generate the catalog</h4>

                <ol>
                    <li>Click the <strong>Admin</strong> tab.</li>
                    <li>Click <strong>Downloads</strong> from the menu.</li>
                    <li>Click <strong>Generate Catalog</strong>.</li>
                    <li>Type <strong>HC Catalog QN YYYY</strong> for the name. <em>Quarter represents the new quarter/the quarter Sales will use it</em>.</li>
                    <li>Click <strong>Generate</strong>.</li>
                    <li>Save the catalog to <strong>Teams > Product and Services Content Private > General > Technology and Services Catalog Versions</strong>.</li>
                </ol>

                <br>

                <h4>Part 2: Upload the catalog</h4>

                <ol>
                    <li>From <strong>Admin > Downloads</strong>, click <strong>Add Version</strong>.</li>
                    <li>Complete form:
                        <ol>
                            <li>Name: <strong>HC Catalog QN YYYY</strong>. <em>Name must align to file name</em>.</li>
                            <li>Type the version number as <strong>YYQVV1</strong>.</li>
                            <li>Enter start and end dates of the quarter that just ended.</li>
                            <li>Click <strong>Browse Files</strong> and select the catalog from Teams.</li>
                        </ol>
                    </li>
                    <li>Click <strong>Add</strong>.</li>
                </ol>

                <br>

                <h4>Part 3: Validate the catalog and send to Sales</h4>

                <ol>
                    <li>QC the catalog on the <strong>Downloads</strong> tab.</li>
                    <li>Send an email with the updated catalog link to Sales.</li>
                </ol>

                <br>
                
                <h3>Updating the Catalog Spreadsheet</h3>

                <p>Complete this task on the first day of each quarter to load a version that shows the current state. Sales will use this version for the new quarter. For example, if I'm uploading on Jan 1, the file would be Q1 2024, and the dates would be Sept 1 to Dec 31 2023.</p>

                <h4>Part 1: Generate the spreadsheet</h4>

                <ol>
                    <li>Click the <strong>Admin</strong> tab.</li>
                    <li>Click <strong>Downloads</strong> from the menu.</li>
                    <li>Click the <strong>Catalog Spreadsheet</strong> subtab. </li>
                    <li>Click <strong>Generate Spreadsheet</strong>.</li>
                    <li>Put the spreadsheet into the <a href="https://healthcarequalitycatalyst.sharepoint.com/:x:/s/ProductandServicesContent/EXMJBthb4_1ElTYRQvEmlrwBQCHX3wyeyUh5kOo6YJrUNw?e=CUVTbQ" target="_blank">HC Excel Spreadsheet</a>. Title on spreadsheet: <strong>Technology and Services Catalog Spreadsheet</strong>; subtitle: <strong>QN YYYY</strong>.</li>
                    <li>Save the catalog to <strong>Teams > Product and Services Content Private > General > Technology and Services Catalog Versions</strong> with the name <strong>HC Catalog Spreadsheet QN YYYY</strong>.</li>
                </ol>

                <h4>Part 2: Upload the spreadsheet</h4>

                <ol>
                    <li>From <strong>Admin > Downloads > Catalog Spreadsheet</strong>, click <strong>Add Version</strong>.</li>
                    <li>Complete form:
                        <ol>
                            <li>Name: <strong>HC Catalog Spreadsheet QN YYYY</strong>. <em>Name must align to file name</em>.</li>
                            <li>Type the version number as <strong>YYQVV2</strong>.</li>
                            <li>Enter start and end dates of the quarter that just ended.</li>
                            <li>Click <strong>Browse Files</strong> and select the spreadsheet from Teams.</li>
                        </ol>
                    </li>
                    <li>Click <strong>Add</strong>.</li>
                </ol>

                <h4>Part 3: Validate the spreadsheet</h4>

                <ol>
                    <li>QC the spreadsheet on the <strong>Downloads</strong> tab.</li>
                </ol>

            </article>
        </hc-modal-body>
    </hc-modal>
</ng-template>